<template>
  <div class="default-footer webdash-footer">
    <div class="FooterGrey" role="contentinfo">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="vehicle-disclaimer text-center">
              <p class="footer-disclaimer"></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="footer-nav-block">
              <div class="FooterMenuA">
                <div class="FooterGreyMenu">
                  <li role="menuitem"><a href="#" target="" title="Home">Home</a></li>
                  <li role="menuitem"><a href="#" target="" title="Contact Us">Contact Us</a></li>
                  <li role="menuitem"><a href="#" target="" title="New Vehicles">New Vehicles</a></li>
                  <li role="menuitem"><a href="#" target="" title="Pre-Owned Vehicles">Pre-Owned
                      Vehicles</a></li>
                  <li role="menuitem"><a href="#" target="" title="Specials">Specials</a></li>
                  <li role="menuitem"><a href="#" target="" title="Financing">Financing</a></li>
                  <li role="menuitem"><a href="#" target="" title="Service &amp; Parts">Service &amp; Parts</a></li>
                  <li role="menuitem"><a href="#" target="" title="About">About</a></li>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row bottom-footer-logos">
          <div class="col-sm-offset-4 col-sm-4">
            <a href="#" rel="nofollow">
              <img alt="Sokal" class="footer-logos sokal-solo-logo img-responsive center-block" data-src="https://d2v1gjawtegg5z.cloudfront.net/assets/gosokal-9fc0e337d3f2eaa8330f651b42b1311d160e043ed7f4606504352a2d7f8161b6.png" src="https://d2v1gjawtegg5z.cloudfront.net/assets/gosokal-9fc0e337d3f2eaa8330f651b42b1311d160e043ed7f4606504352a2d7f8161b6.png">
              <p class="logo-text text-center">an Automotive Advertising Agency</p>
            </a>
          </div>
        </div>
      </div>
      </div>
      <div class="FooterBlack" role="contentinfo">
      <div class="container">
        <div class="row">
          <div class="col-sm-4 text-center">
            <span class="left_footer_text">©&nbsp;{{ new Date().getFullYear() }} &nbsp;<span class="footer-address">123 Main St, City, NC 27614&nbsp;&nbsp;</span></span>
            <span><br>Sales: 555-555-5555 &nbsp;</span>
          </div>
          <div class="col-sm-8 text-center">
            <span><a class="toggle-sitemap" href="#">Site Map</a>&nbsp; · &nbsp;<a href="#">Privacy Policy</a>&nbsp; · &nbsp;<a href="#">Accessibility Policy</a>&nbsp; · &nbsp;<a href="#">Legal Disclaimer</a></span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 text-center">
            <div class="social-media-icons">
              <a :style="linkColor" aria-label="Facebook" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="Facebook" href="#">
                <i aria-hidden="true" class="fa fa-facebook"></i>
              </a>
              <a :style="linkColor" aria-label="Twitter" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="Twitter" href="#">
                <i aria-hidden="true" class="fa fa-twitter"></i>
              </a>
              <a :style="linkColor" aria-label="Instagram" class="social-media-link track-click" data-action="click" data-category="Social Media" data-label="Instagram" href="#" rel="nofollow">
                <i aria-hidden="true" class="fa fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    ...mapGetters(["brandData"]),
    linkColor () {
      if (this.brand === 'none') {
        return {'--a-color':'#cc0000'};
      } else if (this.brand === 'toyota' || this.brand === 'nissan' || this.brand === 'mitsubishi' || this.brand === 'honda' || this.brand === 'chevrolet') {
        return {'--a-color':'var(--primary-color)'};
      } else {
        return {'--a-color':'rgba(255,255,255,.7)'};
      }
    }
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.footer-nav-block {
  width: 100%;
}
.FooterGrey {
  width: 100%;
  float: left;
  padding: 15px 0px 15px 0px;
  background: #222222;
}
.FooterMenuA {
  float: left;
  width: 100%;
}
.FooterGreyMenu {
  width: 100%;
  float: left;
  margin: 15px 0px 0px 0px;
  text-align: center;
}
.FooterGreyMenu ul {
  margin: 0px;
  padding: 0px;
}
.FooterGreyMenu li {
  display: inline-block;
  text-align: center;
  list-style: none;
  color: #d6d6d6;
  font-size: 13px;
  border-bottom: 1px solid #343434;
  padding-bottom: 3px;
  margin: 5px 0px 5px 0px;
  margin-right: 20px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
.FooterGreyMenu li a {
  color: #d6d6d6;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
.FooterGreyMenu li:hover {
  border-bottom: 1px solid #fff;
}
.FooterGreyMenu li:hover a, .FooterGreyMenu li a:hover {
  color: #fff;
  text-decoration: none;
}
.FooterGrey img {
  max-width: 220px;
  margin: 5px auto;
}
.FooterBlack {
  background: #1b1b1b;
  width: 100%;
  float: left;
  padding: 12px 0px 12px 0px;
  font-size: 13px;
  color: #fff;
  padding-bottom: 70px;
}
.FooterBlack .social-media-icons {
  font-size: 20px;
  text-align: center;
  clear: right;
}
.FooterBlack .social-media-icons > a {
  float: none;
  color: #fff;
  margin-left: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
.FooterBlack .social-media-icons > a:first-of-type {
  margin-left: 0px;
}
.FooterBlack .social-media-icons > a:hover {
  color: var(--a-color);
}
@media only screen and (min-width: 768px) and (max-width: 900px) {
  .FooterGreyMenu li {
    font-size: 12px;
  }
}
@media only screen and (min-width: 150px) and (max-width: 768px) {
  .FooterGreyMenu li {
    font-size: 12px;
  }
  .FooterBlack .social-media-icons {
    margin-top: 20px;
  }
}
</style>
